import { types } from "../action-types";

const initialState = {
  loading: false,
  skills: [],
  error: false,
};

const getSearchSkillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET__SEARCH_SKILLS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_SEARCH_SKILLS_SUCCESS:
      return {
        ...state,
        loading: false,
        skills: action.payload,
        error: false,
      };
    case types.GET_SEARCH_SKILLS_FAILURE:
      return {
        ...state,
        loading: false,
        skills: [],
        error: true,
      };
    default:
      return state;
  }
};

export default getSearchSkillsReducer;
